import { render, staticRenderFns } from "./Collection_Updated.vue?vue&type=template&id=ad2022c0&scoped=true"
import script from "./Collection_Updated.vue?vue&type=script&lang=js"
export * from "./Collection_Updated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2022c0",
  null
  
)

export default component.exports